import RemoveSelectionImpl from './remove-selection.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component to display remove selection in single bet.
 *
 * @class RemoveSelection
 * @memberof Mojito.Modules.BetslipView.BetComponents
 */

/**
 * RemoveSelection prop types.
 *
 * @property {Function} [cbRemoveBet = ()=>{}] - Callback for when a bet is removed from the slip.
 * @property {Mojito.Services.Betslip.types.Bet} bet - Bet.
 * @property {string} [selectionId] - Selection id for the removal leg of a Bet Builder bet.
 *
 * @memberof Mojito.Modules.BetslipView.BetComponents.Odds
 */
const propTypes = {
    cbRemoveBet: PropTypes.func,
    bet: PropTypes.object,
    selectionId: PropTypes.string,
};

const defaultProps = {
    cbRemoveBet: noop,
};

export default UIView('RemoveSelection', RemoveSelectionImpl, propTypes, defaultProps);
